import React from 'react';
import { ModalContextType, ModalType, useModalContext } from 'src/hooks/useModal';
import { ScrollModal } from '../../../components/primitives/ScrollModal';
import { EControlPositionType } from '../../../types/uniswapTokens';
import { PositionModalWrapper } from '../FlowCommons/PositionModalWrapper';
import { DeleveragePositionModalContent } from './DeleveragePositionModalContent';

export const DeleveragePositionModal = () => {
  const { type, args, close } = useModalContext() as ModalContextType<{
    positionAddress: string;
    controlType: EControlPositionType;
  }>;

  return (
    <ScrollModal open={type === ModalType.DeleveragePosition} setOpen={close}>
      <PositionModalWrapper
        positionAddress={args.positionAddress}
        title="Deleverage"
        modernStyle={true}
        controlType={args.controlType}
      >
        {(params) => (
          <DeleveragePositionModalContent controlType={args.controlType} {...params} />
        )}
      </PositionModalWrapper>
    </ScrollModal>
  );
};
